import React, { createContext, useContext } from 'react';

import { useRootStore } from '@/configs/store';
import { useLogsMode } from '@/features/logsMode';
import { useLocalStore } from '@/hooks/useLocalStore';

import { TaskStore } from './TaskStore';

interface ProviderProps {
  children: React.ReactNode;
}

const TaskStoreContext = createContext<TaskStore | null>(null);

export const TaskStoreProvider: React.FC<ProviderProps> = ({ children }) => {
  const { userStore, alertsStore } = useRootStore();

  const mode = useLogsMode();
  const taskStore = useLocalStore(() => new TaskStore({ userStore, alertsStore, mode }));

  return <TaskStoreContext.Provider value={taskStore.store}>{children}</TaskStoreContext.Provider>;
};

export function useTaskStore() {
  const store = useContext(TaskStoreContext);

  if (!store) throw new Error('useTaskStore must be used within TaskStoreProvider');

  return store;
}
